import { Component, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'ca-checkin-health',
  templateUrl: './checkin-health.component.html',
  styleUrls: ['./checkin-health.component.scss']
})
export class CheckInHealthComponent {
  @ViewChild('lineChart')
  lineChart;

  @Input()
  set totals(data: { excellent: number; fair: number; good: number; poor: number }) {
    if (!data) {
      return;
    }
    this.barChartData = [
      {
        data: [data.excellent],
        label: 'Excellent'
      },
      {
        data: [data.good],
        label: 'Good'
      },
      {
        data: [data.fair],
        label: 'Fair'
      },
      {
        data: [data.poor],
        label: 'Poor'
      }
    ];
  }

  @Input()
  set dailySummary(data: {
    [date: string]: { excellent: number; good: number; fair: number; poor: number };
  }) {
    if (!data || Object.getOwnPropertyNames(data).length == 0) {
      return;
    }
    let rangeScore = 0;
    let rangeCount = 0;

    let dates = Object.getOwnPropertyNames(data);
    let lineData = dates.sort().map(date => {
      if (!data[date]) {
        return undefined;
      }
      let count = data[date].excellent + data[date].good + data[date].good + data[date].poor;
      let grossScore = data[date].excellent * 3 + data[date].good * 2 + data[date].fair;
      let score = Math.round((grossScore / count) * 100) / 100;
      rangeScore += grossScore;
      rangeCount += count;
      return score;
    });

    if (!lineData[0]) {
      lineData[0] = rangeScore / rangeCount;
    }
    if (!lineData[lineData.length - 1]) {
      lineData[lineData.length - 1] = rangeScore / rangeCount;
    }

    this.lineChartData = [{ data: lineData, label: 'Health', fill: false }];

    // the graph does not render unless there is a label for every datapoint
    // We don't want labels, so render an empty array
    this.lineLabels = dates.map(() => '');
    this.calculateAverage();
  }

  public barChartLabels = [];
  public lineLabels = [];
  public lineOptions = {
    responsive: true,
    spanGaps: true,
    elements: {
      line: {
        tension: 0.3,
        spanGaps: true
      }
    },
    scales: {
      yAxes: [
        {
          ticks: {
            stepSize: 1,
            max: 4,
            beginAtZero: true,
            // Include a dollar sign in the ticks
            callback: (value, index, values) => {
              if (value % 1 == 0) return this.messages[Math.round(value)];
            }
          }
        }
      ]
    }
  };

  public barOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: false,
          ticks: {
            beginAtZero: true
          }
        }
      ],
      yAxes: [
        {
          stacked: false,
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };

  public barColors = [
    {
      // great
      backgroundColor: 'rgba(79,177,166,0.8)',
      borderColor: 'rgba(79,177,166,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    {
      // good
      backgroundColor: 'rgba(254,211,60,0.8)',
      borderColor: 'rgba(254,211,60,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    {
      // fair
      backgroundColor: 'rgba(249,163,44,0.8)',
      borderColor: 'rgba(249,163,44,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    {
      // poor
      backgroundColor: 'rgba(241,73,33,0.8)',
      borderColor: 'rgba(241,73,33,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];
  public lineColors = [
    {
      // great
      backgroundColor: <any>'rgba(79,177,166,0.8)',
      borderColor: <any>'rgba(79,177,166,1)',
      pointBackgroundColor: <any>'rgba(148,159,177,0)',
      pointBorderColor: 'rgba(255,255,255,0)',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  public barChartData: any[] = [];
  public lineChartData: any[] = [];

  avgRating;
  healthMessage;

  messages = ['Poor', 'Fair', 'Good', 'Excellent'];

  constructor() {}

  ngOnInit() {
    // Generate the gradient used to render the line graph
    let ctx: CanvasRenderingContext2D = this.lineChart.nativeElement.getContext('2d');
    let grad = ctx.createLinearGradient(0, 280, 0, 0);
    grad.addColorStop(0, '#f14921');
    grad.addColorStop(0.25, '#F9A32C');
    grad.addColorStop(0.5, '#FED33C');
    grad.addColorStop(0.75, '#4FB1A6');
    this.lineColors[0].backgroundColor = grad;
    this.lineColors[0].borderColor = grad;
  }

  calculateAverage() {
    this.avgRating =
      (this.barChartData[0].data[0] * 4 +
        this.barChartData[1].data[0] * 3 +
        this.barChartData[2].data[0] * 2 +
        this.barChartData[3].data[0]) /
      (this.barChartData[0].data[0] +
        this.barChartData[1].data[0] +
        this.barChartData[2].data[0] +
        this.barChartData[3].data[0]);

    this.healthMessage = this.messages[Math.round(this.avgRating) - 1];
    return this.avgRating;
  }
}
